import { Tenant, Team, SurveyCompleteUser, PVAKeyValue, ScoreCard, Language, Survey } from '../models';
import { HasId } from '../interfaces';

export class OrganizationText {
    public id: number;
    public textType: string;
    public value: string;
    public keyName: string;
    public languageId: number;
    public language: Language;  
    public showModal: boolean;
    public surveyID: number;
    public survey: Survey;  
}

export class OrganizationSurvey {
    public organizationID: number;
    public surveyID: number;
    public surveyVersionID?: number;
}
export class OrganizationReportType {
    public organizationID: number;
    public surveyReportTypeID: number;
}

export class Organization implements HasId {
    public id: number;
    public name: string;
    public tenant: Tenant;
    public organizationSurveys: OrganizationSurvey[];
    public organizationReportTypes: OrganizationReportType[];
    public scoreCards: ScoreCard[];
    public scoreCardCount: number;
    public isDeactivated: boolean;
    public isDeleted: boolean;
    public teams: Team[];
    public expirationDate: Date;
    public surveyCompleteUser: SurveyCompleteUser[];
    public pvaKeyValues: PVAKeyValue[];
    public isLicensee: boolean;
    public hasSubscription: boolean;
    public organizationTexts: OrganizationText[];

    // this is the base64 string for the logo
    public logo: string;
    public logoStyle: string;
    public logoSizeStyle: string;
    public showLogoInNav: boolean;
    public useWhiteBackgroundInNav: boolean;
}


// WEBPACK FOOTER //
// ./src/models/Organization.tsx